document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header');
  const scrollThreshold = 10;

  window.addEventListener('scroll', function() {
    if (window.scrollY > scrollThreshold) {
      header.classList.add('header--scrolled');
    } else {
      header.classList.remove('header--scrolled');
    }
  });
});